import React from 'react';
import classNames from 'classnames';
import useScreen from 'hooks/useScreen';
import ImageContentBlock from './components/ImageContentBlock';
import CardCarousel from '../image-slider-standard/components/CardCarousel';
import FixedWidthContainer from '../FixedWidthContainer';

const MOBILE_SCROLL_TEXT = 'Scroll for more >';

const MultipleBlocks = ({ config }) => {
  const {
    imageComponent: { size = 'Full Width' },
    blockSectionConfig: { columns = 2 },
    blockSection: {
      block1,
      block2,
      block3,
      block4,
      block5,
      block6,
      block7,
      block8,
    },
  } = config;
  const { isMobile } = useScreen();
  const blocksArray = [
    block1,
    block2,
    block3,
    block4,
    block5,
    block6,
    block7,
    block8,
  ].slice(0, columns);

  if (columns > 4 && !isMobile)
    return (
      <FixedWidthContainer
        className={classNames({
          'w-full max-w-none': size === 'Full Width',
          'max-w-[1400px]': size === 'Full Page',
        })}
      >
        <CardCarousel
          imageHeight={340}
          imageWidth={340}
          navType="Button"
          variant="blog-slider"
          visibleSlides={4}
          fullHeight
        >
          {blocksArray.map(
            (blockConfig, index) =>
              blockConfig && (
                <ImageContentBlock
                  blockConfig={blockConfig}
                  key={`blockSection-${blockConfig?.title?.text}-${
                    blockConfig?.body?.text
                  }-${index + 1}`}
                />
              )
          )}
        </CardCarousel>
      </FixedWidthContainer>
    );

  return (
    <FixedWidthContainer
      className={classNames({
        'w-full max-w-none': size === 'Full Width',
        'max-w-[1400px]': size === 'Full Page',
      })}
    >
      {isMobile && (
        <span className="block w-full text-left text-xs" aria-live="polite">
          {MOBILE_SCROLL_TEXT}
        </span>
      )}
      <div className="w-full flex">
        <div
          className={classNames('flex flex-row gap-2 md:gap-4 [&>*]:!mt-0', {
            'w-full': size === 'Full Width',
            'max-w-[1400px]': size === 'Full Page',
            'overflow-x-auto snap-x snap-mandatory [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden': isMobile,
          })}
        >
          {blocksArray.map(
            (blockConfig, index) =>
              blockConfig && (
                <ImageContentBlock
                  blockConfig={blockConfig}
                  key={`blockSection-${blockConfig?.title?.text}-${
                    blockConfig?.body?.text
                  }-${index + 1}`}
                  isMobile={isMobile}
                />
              )
          )}
        </div>
      </div>
    </FixedWidthContainer>
  );
};

export default MultipleBlocks;
